import React from "react";
import {
  Grid,
  FormGroup,
  Button,
  withStyles,
  MenuItem,
  InputLabel,
  Select,
  Input,
  FormControl,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  FormLabel,
  Radio,
} from "material-ui";
import Icon from "material-ui/Icon";
import Title from "../../ui/title";
import Content from "../../ui/content";
import styles from "./styles";
import ConfirmDialog from "../../common/dialog/confirm";
import { withRouter } from "react-router-dom";
import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { validateFormData } from "../../../common/formtool";
import { ToInt, ToReal, ToDuration } from "../../../common/datatypetool";
import { CustomDataEnum } from "../customdata/customenum";
import Duration from "../common/duration";
import FrameLossLimit from "../common/framelosslimit";

class CableData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      setUpType: null,
      trafficType: 0,
      ieee802_3: false,
      lossLimit: 9,
      numberOfSessions: null,
      expectedLineRate: [],
      isChanged: false,
      trafficBandwidth: null,
      frameSize: [],
      trafficRate: 0.1,
      infoRate: 968,
      frameLossLimit: 0,
      countValue: 0,
      percentValue: 0,
      duration: 10,
      frameFill: [],
      hours: "00",
      minutes: "00",
      seconds: "00",
      hideCount: false,
      countValue: 0,
      percentValue: 0,
      countDefaultValue: 0,
      percentDefaultValue: 0,
      defaultDurationValue: 10,
      errors: {},
      isRestore: false,
      showRestoreConfirm: false,
      isCabledataUpdated: false,
    };
  }

  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false,
    });
  };

  onBackYesClick = () => {
    this.setState({
      showConfirmBack: false,
    });
    this.onCableDataSave();
  };

  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true,
      });
    }
  };

  updateCableData = (subtestSettings) => {
    this.splitDuration(subtestSettings.duration);
    this.setState({
      id: subtestSettings.id,
      trafficBandwidth: subtestSettings.trafficbandwidth,
      frameSize: this.mapEnumValue(subtestSettings.framesize, "framesize"),
      frameFill: this.mapEnumValue(subtestSettings.framefill, "framefill"),
      lossLimit: subtestSettings.losslimit < 8 ? 9 : subtestSettings.losslimit,
      trafficRate: subtestSettings.trafficrate,
      infoRate: subtestSettings.inforate,
      frameLossLimit: subtestSettings.framelosslimit,
      countValue: subtestSettings.count,
      percentValue: subtestSettings.percent,
      duration: subtestSettings.duration,
      hideCount: subtestSettings.framelosslimit === 1 ? true : false,
      trafficType: subtestSettings.traffictype,
      ieee802_3: subtestSettings.ieee802_3 === 0 ? false : true,

      numberOfSessions: subtestSettings.noofsessions,
      expectedLineRate: this.mapEnumValue(
        subtestSettings.expectedlinerate,
        "expectedlinerate"
      ),
      setUpType: subtestSettings.setuptype,
      countDefaultValue: subtestSettings.count,
      percentDefaultValue: subtestSettings.percent,
      defaultDurationValue: subtestSettings.duration,
    });
  };

  validateDefaultValue = () => {
    const {
      defaultDurationValue,
      countDefaultValue,
      percentDefaultValue,
      hours,
      minutes,
      seconds,
    } = this.state;
    const { translate } = this.props;
    let currentErrors = this.state.errors;
    let errors;
    let validationObj = {
      duration: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 10,
          maxValue: 86399,
          message: translate("formfield_error_general_required"),
        },
      },
      countValue: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0,
          maxValue: 99999,
          message: translate("formfield_error_general_required"),
        },
        type: {
          value: "numeric",
          message: translate("formfield_error_general_required"),
        },
      },
      percentValue: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0.0,
          maxValue: 10.0,
          message: translate("formfield_error_general_required"),
        },
      },
    };

    let duration =
      parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
    errors = validateFormData(
      { ...this.state, duration: duration },
      validationObj
    );
    if (duration === 0) {
      errors["duration"] = {};
    }
    if (Object.keys(errors).length && errors.duration) {
      delete currentErrors.duration;
      this.splitDuration(defaultDurationValue);
      this.setState({ duration: defaultDurationValue, errors: currentErrors });
    }
    if (Object.keys(errors).length && errors.percentValue) {
      delete currentErrors.percentValue;
      this.setState({
        percentValue: percentDefaultValue,
        errors: currentErrors,
      });
    }
    if (Object.keys(errors).length && errors.countValue) {
      delete currentErrors.countValue;
      this.setState({ countValue: countDefaultValue, errors: currentErrors });
    }
  };

  toFixed = (e, numberOfDigit, newErrors) => {
    let value = ToReal(e.target.value);
    value = value.split(".");
    if (value.length > 2) {
      this.setState({ errors: { [e.target.name]: {} } });
    } else if (value.length === 1) {
      this.setState({
        [e.target.name]: value[0],
        isChanged: true,
        isRestore: false,
        errors: newErrors,
      });
    } else {
      if (value[1].length > numberOfDigit) {
        e.preventDefault();
      } else {
        this.setState({
          [e.target.name]: ToReal(e.target.value),
          isChanged: true,
          isRestore: false,
          errors: newErrors,
        });
      }
    }
  };

  onChange = (e) => {
    const {
      errors,
      trafficBandwidth,
      frameSize,
      trafficRate,
      lossLimit,
    } = this.state;
    let newErrors = errors;
    switch (e.target.name) {
      case "frameSize":
        {
          let newFrameSize = this.mapEnumValue(e.target.value, "framesize");
          this.setState({
            frameSize: newFrameSize,
            isChanged: true,
            isRestore: false,
          });
        }
        break;
      case "frameFill":
        {
          this.setState({
            frameFill: this.mapEnumValue(e.target.value, "framefill"),
            isChanged: true,
            isRestore: false,
          });
        }
        break;

      case "lossLimit":
        {
          this.setState({
            lossLimit: parseInt(e.target.value),
            isChanged: true,
            isRestore: false,
          });

        }
        break;
      case "expectedLineRate":
        {
          this.setState({
            expectedLineRate: this.mapEnumValue(
              e.target.value,
              "expectedlinerate"
            ),
            isChanged: true,
            isRestore: false,
          });
        }
        break;
      case "countValue":
        delete newErrors[e.target.name];
        let onlyInterger = ToInt(e.target.value);
        this.setState({
          [e.target.name]: onlyInterger,
          isChanged: true,
          errors: newErrors,
          isRestore: false,
        });
        break;
      case "ieee802_3":
        this.validateDefaultValue();
        this.setState({
          [e.target.name]: !this.state.ieee802_3,
          isChanged: true,
          errors: newErrors,
          isRestore: false,
        });
        break;
      case "percentValue":
        delete newErrors[e.target.name];
        this.toFixed(e, 5, newErrors);
        break;
      default:
        {
          delete newErrors[e.target.name];
          this.setState({
            [e.target.name]: ToReal(e.target.value),
            isChanged: true,
            errors: newErrors,
            isRestore: false,
          });
        }
        break;
    }
  };

  splitDuration = (duration) => {
    let hours = 0,
      minutes = 0,
      seconds = 0;
    if (parseInt(duration) >= 3600) {
      hours = parseInt(duration / 3600);
      duration = parseInt(duration % 3600);
    }
    if (parseInt(duration) >= 60) {
      minutes = parseInt(duration / 60);
      duration = parseInt(duration % 60);
    }
    this.setState({
      hours: ToDuration(hours + ""),
      minutes: ToDuration(minutes + ""),
      seconds: ToDuration(duration + ""),
      isRestore: false,
    });
  };

  mapEnumValue = (key, type) => {
    switch (type) {
      case "expectedlinerate":
        return CustomDataEnum.ExpectedLineRate.filter(
          (data) => data.key === key
        );
      case "framesize":
        return CustomDataEnum.FrameSize.filter((data) => data.key === key);
      case "framefill":
        return CustomDataEnum.FrameFill.filter((data) => data.key === key);
    }
  };

  onCableDataSave = () => {
    const { hours, minutes, seconds, isRestore } = this.state;
    const { translate, error, isTestEdit } = this.props;

    let errors;
    let validationObj = {
      duration: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 10,
          maxValue: 86399,
          message: translate("formfield_error_general_required"),
        },
      },
      countValue: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0,
          maxValue: 99999,
          message: translate("formfield_error_general_required"),
        },
        type: {
          value: "numeric",
          message: translate("formfield_error_general_required"),
        },
      },
      percentValue: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0.0,
          maxValue: 10.0,
          message: translate("formfield_error_general_required"),
        },
      },
    };

    let duration =
      parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
    errors = validateFormData(
      { ...this.state, duration: duration },
      validationObj
    );
    if (duration === 0) {
      errors["duration"] = {};
    }
    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }

    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      const {
        id,
        trafficBandwidth,
        frameSize,
        trafficRate,
        infoRate,
        frameLossLimit,
        countValue,
        percentValue,
        frameFill,
        trafficType,
        ieee802_3,
        lossLimit,
        expectedLineRate,
        numberOfSessions,
        hideCount,
      } = this.state;
      let payload = {
        id: id,
        setuptype: "cabledata",
        traffictype: trafficType,
        trafficbandwidth: trafficBandwidth,
        trafficrate: trafficRate,
        inforate: infoRate,
        framesize: frameSize[0].key,
        framelosslimit: hideCount ? 1 : 0,
        count: countValue,
        percent: percentValue === "" ? 0 : percentValue,
        duration: duration,
        framefill: frameFill[0].key,
        losslimit: lossLimit,
        ieee802_3: 0, // ieee802_3 === true ? 1 : 0,
        expectedlinerate: expectedLineRate[0].key,
        noofsessions: numberOfSessions,
      };
      if (!error) {
        this.setState({
          isChanged: false,
          errors: {},
          countDefaultValue: countValue,
          percentDefaultValue: percentValue,
          frameLossDefaultValue: frameLossLimit,
        });
      } else {
        this.setState({ isChanged: false, errors: {} });
      }
      //this.props.updateSubTestSettings(payload);

      if (isTestEdit) {
        this.props.updateSubTestSettings(this.props.selectedTest, payload);
        this.props.handleClose();
      } else {
        this.props.updateSubTestSettings(payload);
      }
      if (isRestore) {
        this.props.deleteDefaultSubtests(this.props.selectedTest);
      }
    }
  };

  renderValue = (selectedValue) => {
    return selectedValue && selectedValue.length && selectedValue[0].value;
  };

  onKeyDown = (event) => {
    if (event.key === ".") {
      event.preventDefault();
    }
  };

  onInput = (event) => {
    let additionMinutes = 0,
      additionalHours = 0;
    let newErrors = this.state.errors;
    delete newErrors["duration"];
    let onlyInteger = ToDuration(event.target.value);
    const { hours, minutes, seconds } = this.state;

    if (event.target.name === "seconds" && parseInt(onlyInteger) > 59) {
      additionMinutes = parseInt(onlyInteger / 60);
      onlyInteger = parseInt(onlyInteger % 60);
      additionMinutes = ToDuration(
        parseInt(minutes) + parseInt(additionMinutes) + ""
      );
      if (parseInt(additionMinutes) > 59) {
        additionalHours = parseInt(additionMinutes / 60);
        additionMinutes = ToDuration(parseInt(additionMinutes % 60) + "");
      }
      additionalHours = ToDuration(
        parseInt(hours) + parseInt(additionalHours) + ""
      );
      this.setState({
        [event.target.name]: ToDuration(onlyInteger + ""),
        minutes: additionMinutes,
        hours: additionalHours,
        isChanged: true,
        isRestore: false,
        errors: newErrors,
      });
    } else if (event.target.name === "minutes" && parseInt(onlyInteger) > 59) {
      additionalHours = parseInt(onlyInteger / 60);
      onlyInteger = parseInt(onlyInteger % 60);
      additionalHours = ToDuration(
        parseInt(hours) + parseInt(additionalHours) + ""
      );
      this.setState({
        [event.target.name]: ToDuration(onlyInteger + ""),
        hours: additionalHours,
        isChanged: true,
        isRestore: false,
        errors: newErrors,
      });
    } else {
      this.setState({
        [event.target.name]: onlyInteger + "",
        isChanged: true,
        isRestore: false,
        errors: newErrors,
      });
    }
  };

  frameLossLimitToggle = () => {
    const { countDefaultValue, percentDefaultValue } = this.state;
    const { translate } = this.props;
    let currentErrors = this.state.errors;
    let errors;
    let validationObj = {
      countValue: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0,
          maxValue: 99999,
          message: translate("formfield_error_general_required"),
        },
        type: {
          value: "numeric",
          message: translate("formfield_error_general_required"),
        },
      },
      percentValue: {
        required: {
          required: translate("formfield_error_general_required"),
        },
        range: {
          minValue: 0.0,
          maxValue: 10.0,
          message: translate("formfield_error_general_required"),
        },
      },
    };

    errors = validateFormData({ ...this.state }, validationObj);
    const missingFieldName = Object.keys(errors)[0];

    if (Object.keys(errors).length) {
      if (errors.countValue) {
        delete currentErrors.countValue;
        this.setState({
          hideCount: !this.state.hideCount,
          isChanged: true,
          isRestore: false,
          errors: currentErrors,
          countValue: countDefaultValue,
        });
      } else {
        delete currentErrors.percentValue;
        this.setState({
          hideCount: !this.state.hideCount,
          isChanged: true,
          isRestore: false,
          errors: currentErrors,
          percentValue: percentDefaultValue,
        });
      }
    } else {
      this.setState({
        hideCount: !this.state.hideCount,
        isChanged: true,
        isRestore: false,
      });
    }
  };

  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true,
    });
  };
  onRestoreConfirm = () => {
    //this.props.updateUpTime(this.props.selectedTest, this.props.upTime);
    this.updateCableData(this.props.subtestSettings);
    this.setState({
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true,
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false,
    });
  };

  render() {
    const {
      isChanged,
      ieee802_3,
      lossLimit,
      frameSize,
      errors,
      hours,
      minutes,
      seconds,
      frameFill,
      hideCount,
      countValue,
      percentValue,
      expectedLineRate,
      isRestore,
    } = this.state;
    const {
      translate,
      classes,
      isTestEdit,
      subtestSettings,
      cabledataDetails,
      testEdit,
      modified,
    } = this.props;

    return (
      <div style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={translate("sub_test_empty_target_search_t3", {
              name: "Cable Data",
            })}
          />
        )}
        <Content translate={translate}>
          {subtestSettings && expectedLineRate && expectedLineRate.length > 0 && (
            <Grid container>
              <Grid item xs={!isTestEdit ? 2 : 0}></Grid>
              <Grid item xs={!isTestEdit ? 8 : 10}>
                <Grid container>
                  <Grid item xs={6}>
                    <FormControl fullWidth margin="normal" error={false}>
                      <InputLabel id="loss-limit">
                        {translate("subtest_test_standard")}
                      </InputLabel>
                      <Select
                        labelId="loss-limit"
                        name="lossLimit"
                        value={lossLimit}
                        onChange={this.onChange}
                        input={<Input value={lossLimit} />}
                        autoWidth={false}
                      >
                        {CustomDataEnum.LossLimit.map((lossLimit) => {
                          return (
                            <MenuItem
                              key={lossLimit.value}
                              value={lossLimit.key}
                            >
                              {lossLimit.value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    {false && <FormControl fullWidth margin="normal" error={false}>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={ieee802_3}
                              onChange={this.onChange}
                              name="ieee802_3"
                            />
                          }
                          label={<b>{translate("subtest_ieee802_3")}</b>}
                        />
                      </FormGroup>
                    </FormControl>}

                    <FormControl fullWidth margin="normal" error={false}>
                      <InputLabel id="expected-line-rate">
                        {translate("subtest_expected_line_rate")}
                      </InputLabel>
                      <Select
                        labelId="expected-line-rate"
                        name="expectedLineRate"
                        renderValue={() => this.renderValue(expectedLineRate)}
                        onChange={this.onChange}
                        input={
                          <Input
                            value={() => this.renderValue(expectedLineRate)}
                          />
                        }
                        autoWidth={false}
                      >
                        {CustomDataEnum.ExpectedLineRate.map(
                          (expectedLineRate) => {
                            return (
                              <MenuItem
                                key={expectedLineRate.value}
                                value={expectedLineRate.key}
                              >
                                {expectedLineRate.value}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal" error={false}>
                      <InputLabel id="frame-size">
                        {translate("uptime_frame_size")}
                      </InputLabel>
                      <Select
                        labelId="frame-size"
                        name="frameSize"
                        renderValue={() => this.renderValue(frameSize)}
                        onChange={this.onChange}
                        input={
                          <Input value={() => this.renderValue(frameSize)} />
                        }
                        autoWidth={false}
                      >
                        {CustomDataEnum.FrameSize.map((frameSize) => {
                          return (
                            <MenuItem
                              key={frameSize.value}
                              value={frameSize.key}
                            >
                              {frameSize.value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}></Grid>
                </Grid>
                {lossLimit == 8 && (
                  <FrameLossLimit
                    translate={translate}
                    classes={classes}
                    errors={errors}
                    onChange={this.onChange}
                    hideCount={hideCount}
                    frameLossLimitToggle={this.frameLossLimitToggle}
                    percentValue={percentValue}
                    countValue={countValue}
                    countStart={0}
                    countEnd={99999}
                    percentStart={"0.00000"}
                    percentEnd={"10.00000"}
                    //disabled={ieee802_3}
                    disabled={!lossLimit == 8}
                  />
                )}

                <Grid container>
                  <Grid item xs={6}>
                    {lossLimit == 8 && (
                      <Duration
                        translate={translate}
                        hours={hours}
                        minutes={minutes}
                        seconds={seconds}
                        errors={errors}
                        classes={classes}
                        onKeyDown={this.onKeyDown}
                        onInput={this.onInput}
                        durationStart={"00:00:10"}
                        durationEnd={"23:59:59"}
                        //disabled={ieee802_3}
                        disabled={!lossLimit == 8}
                      />
                    )}

                    <FormControl fullWidth margin="normal" error={false}>
                      <InputLabel id="frame-fill">
                        {translate("subtest_frame_fill")}
                      </InputLabel>
                      <Select
                        labelId="frame-fill"
                        disabled={true}
                        name="frameFill"
                        renderValue={() => this.renderValue(frameFill)}
                        onChange={this.onChange}
                        input={
                          <Input value={() => this.renderValue(frameFill)} />
                        }
                        autoWidth={false}
                      >
                        {CustomDataEnum.FrameFill.map((frameFill) => {
                          return (
                            <MenuItem
                              key={frameFill.value}
                              value={frameFill.key}
                            >
                              {frameFill.value}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}></Grid>
                </Grid>
                {!isTestEdit && (
                  <div align="right">
                    <Button
                      className={classes.saveTarget}
                      disabled={!isChanged}
                      color="accent"
                      raised
                      mini
                      onClick={this.onCableDataSave}
                    >
                      {translate("sub_set_ping_save_target")}
                    </Button>
                  </div>
                )}
              </Grid>
              <Grid item xs={!isTestEdit ? 2 : 0}></Grid>
            </Grid>
          )}
          {!isTestEdit && (
            <ConfirmDialog
              open={this.state.showConfirmBack}
              title={translate("sub_test_ping_delete_confirm_title", {
                name: "Cable Data",
              })}
              contentText={translate("sub_test_go_back_confirm_text")}
              cancelText={translate("general_cancel")}
              onCancel={this.hideBackConfirmModal}
              yesText={translate("back_btn_yes")}
              noText={translate("back_btn_no")}
              backText={translate("back_btn_go_back")}
              onYes={this.onBackYesClick}
              onNo={this.onBackNoClick}
              onBack={this.hideBackConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.state.showRestoreConfirm}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("restore_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.onRestoreConfirm}
              onCancel={this.hideRestoreConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.props.showTestCreationCancelConfirmation}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("st_test_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.props.onTestCreationCancelConfirm}
              onCancel={this.props.hideTestCreationCancelConfirm}
            />
          )}
        </Content>
        {isTestEdit &&
          subtestSettings &&
          expectedLineRate &&
          expectedLineRate.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "inline-block", marginLeft: "20px" }}>
                {cabledataDetails && !testEdit ? (
                  <Button
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                    className={classes.restoreButton}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : testEdit && modified ? (
                  <Button
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                    className={classes.restoreButton}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : null}
              </div>
              <div style={{ display: "inline-block", marginRight: "20px" }}>
                <Button
                  disabled={!isChanged}
                  color="accent"
                  raised
                  className={classes.saveTarget}
                  onClick={() => this.onCableDataSave()}
                >
                  {translate("general_continue")}
                </Button>
              </div>
            </div>
          )}
      </div>
    );
  }

  // component life cycles
  componentWillMount() {
    const { getSubtestSettings } = this.props;
    getSubtestSettings("cabledata");
  }

  componentWillReceiveProps(nextProps) {
    const { subtestSettings, isTestEdit, cabledataDetails } = nextProps;

    if (isTestEdit && !cabledataDetails) {
      if (subtestSettings && subtestSettings != this.props.subtestSettings) {
        this.updateCableData(subtestSettings);
      }
    } else if (isTestEdit && cabledataDetails) {
      if (
        (cabledataDetails && this.props.cabledataDetails != cabledataDetails) ||
        !this.state.isCabledataUpdated
      ) {
        this.updateCableData(cabledataDetails);
        this.setState({ isCabledataUpdated: true });
      }
    } else {
      if (subtestSettings && subtestSettings != this.props.subtestSettings) {
        this.updateCableData(subtestSettings);
      }
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

}

export default withRouter(withStyles(styles)(CableData));



// WEBPACK FOOTER //
// ./src/components/subtestsetting/cabledata/index.js